import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BSOatsOatmealProduct from 'models/BSOatsOatmealProduct'
import BSOatsOatmealPackage from './BSOatsOatmealPackage'

const productOptions = {
  packagingInfo: <BSOatsOatmealPackage />,
  productTitle: 'Brand Specific Oats/Oatmeal',
  model: BSOatsOatmealProduct,
  validCategories: ['16'],
  validSubCategories: ['005BS'],
  brandSpecific: true,
}

const BSOatsOatmeal = () => <ProductForm product={productOptions} />

export default BSOatsOatmeal
